import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, Box } from '@material-ui/core';
import classNames from 'classnames';
import GoalsAndObjectives from 'Components/UI/Snapshot/Goals/GoalsAndObjectives';
import BalanceSheetContainer from 'Components/UI/Snapshot/BalanceSheetContainer';
import Holdings from 'Components/UI/Snapshot/Holdings';
import RecommendedComparison from 'Components/UI/Snapshot/Holdings/RecommendedComparison';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { QueryVal, removeQuery, addQuery } from 'Helpers/Query';
import { useTheme } from '@material-ui/core/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { Slide } from '@mui/material';
import {
  FDBodyText, FDBox,
} from '@facet-wealth/design';
import CashFlow from './CashFlow';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  content: {
    width: theme.dimensions.xxl,
  },
  jumboContent: {
    minWidth: theme.dimensions.xxl,
    width: '100%',
  },
  hide: {
    display: 'none',
  },
}));

export const BALANCE_SHEET = 'balanceSheet';
export const CASH_FLOW = 'cashFlow';
export const GOALS_AND_OBV = 'goalsAndObj';
export const HOLDINGS = 'holdings';
export const HOLDINGS_COMPARISON = 'holdingsComp';
// If amending this list, make sure to add a new option to the advisor search
const tab = 'tab';

const Snapshot = () => {
  const { householdResource } = useSimpleHousehold();
  const classes = useStyles();
  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Snapshot',
    isPageView: true,
  });

  const [selectedTab, setSelectedTab] = useState(
    QueryVal(tab) || BALANCE_SHEET,
  );

  useComponentDidMount(null, () => removeQuery(tab));

  const holdingsFeatureToggle = householdResource?.relationship('holdings');
  const portfolioFeatureToggle = householdResource?.relationship('portfolio');
  return (
    <div
      className={classes.root}
      test={'snapshot-root'}
      {...rootNodeProps}
    >
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={(e, val) => {
          setSelectedTab(val);
          addQuery({ [tab]: val });
        }}
        aria-label="disabled tabs example"
      >
        <Tab value={BALANCE_SHEET} label="Balance Sheet" />
        <Tab value={CASH_FLOW} label="Cash Flow" />
        <Tab value={GOALS_AND_OBV} label="Goals and Objectives" />
        {holdingsFeatureToggle && <Tab value={HOLDINGS} label="Holdings" />}
        {portfolioFeatureToggle && <Tab value={HOLDINGS_COMPARISON} label="Holdings Comparison" />}
      </Tabs>
      <FDBox paddingY={4}>
        <FDBodyText value={'The information here is for illustrative purposes only.  It should not be used as the basis for any member recommendations.'} size={'lg'} />
      </FDBox>
      <Slide direction="left" in={selectedTab === BALANCE_SHEET} unmountOnExit>
        <Box className={classNames(classes.content, { [classes.hide]: selectedTab !== BALANCE_SHEET })}>
          <BalanceSheetContainer />
        </Box>
      </Slide>
      <Slide direction="left" in={selectedTab === CASH_FLOW} unmountOnExit>
        <Box className={classNames(classes.content, { [classes.hide]: selectedTab !== CASH_FLOW })}>
          <CashFlow />
        </Box>
      </Slide>
      <Slide direction="left" in={selectedTab === GOALS_AND_OBV} unmountOnExit>
        <Box className={classNames(classes.content, { [classes.hide]: selectedTab !== GOALS_AND_OBV })}>
          <GoalsAndObjectives />
        </Box>
      </Slide>
      {holdingsFeatureToggle && (
        <Slide direction="left" in={selectedTab === HOLDINGS} unmountOnExit>
          <Box className={classNames(classes.jumboContent, { [classes.hide]: selectedTab !== HOLDINGS })}>
            <Holdings />
          </Box>
        </Slide>
      )}
      {portfolioFeatureToggle && (
        <Slide direction="left" in={selectedTab === HOLDINGS_COMPARISON} unmountOnExit>
          <Box className={classNames(classes.jumboContent, { [classes.hide]: selectedTab !== HOLDINGS_COMPARISON })}>
            <RecommendedComparison />
          </Box>
        </Slide>
      )}
    </div>
  );
};

export default Snapshot;
